type TurnstileRuntimeConfig = {
  nodeEnv?: string;
  siteKey?: string;
};

export const getTurnstileSiteKey = ({
  nodeEnv = process.env.NODE_ENV,
  siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY,
}: TurnstileRuntimeConfig = {}) => (nodeEnv === 'production' ? siteKey?.trim() || '' : '');
